import {
  useEffect,
  useState
} from "react";

import MainLayout from "../../components/layout/MainLayout";

import {
  getProducts,
  createProduct,
  updateProduct,
  deleteProduct
} from "../../api/productApi";

import {
  getDesigns
} from "../../api/designApi";

import {
  FaPlus,
  FaEdit,
  FaTrash,
  FaCubes
} from "react-icons/fa";

const Products = () => {

  const [products,setProducts] =
  useState([]);

  const [designs,setDesigns] =
  useState([]);

  const [showModal,setShowModal] =
  useState(false);

  const [editingId,setEditingId] =
  useState(null);

  const [form,setForm] =
  useState({

    product_code:"",
    product_name:"",
    design_id:"",
    size:"",
    gsm:"",
    unit:"pcs",
    minimum_stock:"",
    status:"active"

  });

  useEffect(()=>{

    loadProducts();

    loadDesigns();

  },[]);

  const loadProducts =
  async()=>{

    const res =
    await getProducts();

    setProducts(
      res.data.data || []
    );

  };

  const loadDesigns =
  async()=>{

    const res =
    await getDesigns();

    setDesigns(
      res.data.data || []
    );

  };

  const saveProduct =
  async(e)=>{

    e.preventDefault();

    if(editingId){

      await updateProduct(
        editingId,
        form
      );

    }
    else{

      await createProduct(
        form
      );

    }

    loadProducts();

    closeModal();

  };

  const closeModal =
  ()=>{

    setShowModal(false);

    setEditingId(null);

    setForm({

      product_code:"",
      product_name:"",
      design_id:"",
      size:"",
      gsm:"",
      unit:"pcs",
      minimum_stock:"",
      status:"active"

    });

  };

  const editProduct =
  (product)=>{

    setEditingId(
      product.id
    );

    setForm(product);

    setShowModal(true);

  };

  const removeProduct =
  async(id)=>{

    if(
      !window.confirm(
        "Delete Product?"
      )
    ) return;

    await deleteProduct(id);

    loadProducts();

  };

  return(

    <MainLayout>

      <div className="card shadow-sm border-0">

        <div className="card-header bg-white d-flex justify-content-between align-items-center">

          <div>

            <h5 className="mb-0">
              Product Master
            </h5>

            <small className="text-muted">
              Manage Finished Goods
            </small>

          </div>

          <button
            className="btn btn-primary"
            onClick={()=>
              setShowModal(true)
            }
          >

            <FaPlus />
            {" "}
            Add Product

          </button>

        </div>

        <div className="card-body">

          <table className="table table-hover align-middle">

            <thead>

              <tr>

                <th>Code</th>
                <th>Product</th>
                <th>Size</th>
                <th>GSM</th>
                <th>Unit</th>
                <th>Min Stock</th>
                <th>Status</th>
                <th>Action</th>

              </tr>

            </thead>

            <tbody>

              {
                products.map(
                  (item)=>(
                    <tr
                      key={item.id}
                    >

                      <td>
                        {item.product_code}
                      </td>

                      <td>

                        <FaCubes
                          className="text-primary me-2"
                        />

                        {item.product_name}

                      </td>

                      <td>
                        {item.size}
                      </td>

                      <td>
                        {item.gsm}
                      </td>

                      <td>
                        {item.unit}
                      </td>

                      <td>
                        {item.minimum_stock}
                      </td>

                      <td>

                        <span
                          className={
                            item.status==="active"
                            ?
                            "badge bg-success"
                            :
                            "badge bg-danger"
                          }
                        >

                          {item.status}

                        </span>

                      </td>

                      <td>

                        <button
                          className="btn btn-warning btn-sm me-2"
                          onClick={()=>
                            editProduct(item)
                          }
                        >

                          <FaEdit />

                        </button>

                        <button
                          className="btn btn-danger btn-sm"
                          onClick={()=>
                            removeProduct(item.id)
                          }
                        >

                          <FaTrash />

                        </button>

                      </td>

                    </tr>
                  )
                )
              }

            </tbody>

          </table>

        </div>

      </div>

      {showModal && (

        <div
          className="modal d-block"
          style={{
            background:
            "rgba(0,0,0,.5)"
          }}
        >

          <div className="modal-dialog modal-lg">

            <div className="modal-content">

              <form
                onSubmit={saveProduct}
              >

                <div className="modal-header">

                  <h5>

                    {
                      editingId
                      ?
                      "Edit Product"
                      :
                      "Add Product"
                    }

                  </h5>

                  <button
                    type="button"
                    className="btn-close"
                    onClick={closeModal}
                  />

                </div>

                <div className="modal-body">

                  <div className="row">

                    <div className="col-md-6 mb-3">

                      <label>
                        Product Code
                      </label>

                      <input
                        className="form-control"
                        value={
                          form.product_code
                        }
                        onChange={(e)=>
                          setForm({
                            ...form,
                            product_code:
                            e.target.value
                          })
                        }
                      />

                    </div>

                    <div className="col-md-6 mb-3">

                      <label>
                        Product Name
                      </label>

                      <input
                        className="form-control"
                        value={
                          form.product_name
                        }
                        onChange={(e)=>
                          setForm({
                            ...form,
                            product_name:
                            e.target.value
                          })
                        }
                      />

                    </div>

                    <div className="col-md-6 mb-3">

                      <label>
                        Design
                      </label>

                      <select
                        className="form-select"
                        value={
                          form.design_id
                        }
                        onChange={(e)=>
                          setForm({
                            ...form,
                            design_id:
                            e.target.value
                          })
                        }
                      >

                        <option value="">
                          Select Design
                        </option>

                        {
                          designs.map(
                            (design)=>(
                              <option
                                key={design.id}
                                value={design.id}
                              >
                                {design.design_name}
                              </option>
                            )
                          )
                        }

                      </select>

                    </div>

                    <div className="col-md-6 mb-3">

                      <label>
                        Size
                      </label>

                      <input
                        className="form-control"
                        value={form.size}
                        onChange={(e)=>
                          setForm({
                            ...form,
                            size:e.target.value
                          })
                        }
                      />

                    </div>

                    <div className="col-md-4 mb-3">

                      <label>
                        GSM
                      </label>

                      <input
                        className="form-control"
                        value={form.gsm}
                        onChange={(e)=>
                          setForm({
                            ...form,
                            gsm:e.target.value
                          })
                        }
                      />

                    </div>

                    <div className="col-md-4 mb-3">

                      <label>
                        Unit
                      </label>

                      <select
                        className="form-select"
                        value={form.unit}
                        onChange={(e)=>
                          setForm({
                            ...form,
                            unit:e.target.value
                          })
                        }
                      >

                        <option value="pcs">
                          PCS
                        </option>

                        <option value="box">
                          BOX
                        </option>

                        <option value="bundle">
                          BUNDLE
                        </option>

                      </select>

                    </div>

                    <div className="col-md-4 mb-3">

                      <label>
                        Minimum Stock
                      </label>

                      <input
                        className="form-control"
                        value={
                          form.minimum_stock
                        }
                        onChange={(e)=>
                          setForm({
                            ...form,
                            minimum_stock:
                            e.target.value
                          })
                        }
                      />

                    </div>

                  </div>

                </div>

                <div className="modal-footer">

                  <button
                    className="btn btn-primary"
                  >

                    Save Product

                  </button>

                </div>

              </form>

            </div>

          </div>

        </div>

      )}

    </MainLayout>

  );

};

export default Products;